import { useEffect, useState } from 'react'
import { CheckCircle2, RefreshCw } from 'lucide-react'
import { foutTekst, vraag } from '../lib/api'
import { klikNaar } from '../lib/router'
import { Logo } from '../onderdelen/Logo'

/* De afmeldlink onderaan een mail. Eén klik is genoeg (AVG): geen inlog, geen vragen. */
export function Afmelden({ token }: { token: string }) {
  const [stand, zet] = useState<'bezig' | 'klaar' | string>('bezig')
  useEffect(() => {
    vraag('afmelden', { token }).then(() => zet('klaar'), (e) => zet(foutTekst(e)))
  }, [token])
  return (
    <div className="inlog">
      <div className="kaart" style={{ textAlign: 'center', justifyItems: 'center' }}>
        <Logo vlak />
        {stand === 'bezig' && <RefreshCw className="draai" />}
        {stand === 'klaar' && <>
          <CheckCircle2 size={44} color="var(--ok)" />
          <h1>Je bent afgemeld</h1>
          <p className="stil">Je krijgt geen aanbiedingen of felicitaties meer per mail. Je punten blijven gewoon staan. Wil je toch weer mail? Zet het aan bij Mijn gegevens.</p>
        </>}
        {stand !== 'bezig' && stand !== 'klaar' && <>
          <div className="melding fout">{stand}</div>
          <p className="stil">Afmelden kan ook zelf: vul op TW1 Club de code van je kaart in en zet bij Mijn gegevens de mail uit.</p>
        </>}
        <a className="knop geel breed" href="/" onClick={klikNaar('/')}>Naar TW1 Club</a>
      </div>
    </div>
  )
}
